module.exports = __webpack_public_path__ + "img/var_undefined.dd7e270.svg";